import type { WsClientFrame } from '@neon-one/auctions-types';
import type { OutbidToastPayload } from '../stores/outbidToast';

// Extracted from App.vue's bidderFrameHandler so the item-vs-bundle branch
// (GT1-360) is unit-testable without mounting the shell. A `bid.outbid`
// frame carries itemId OR bundleId (never both) — gating on itemId alone
// silently drops every bundle outbid.
export function resolveOutbidToast(
  frame: WsClientFrame,
  eventSlug: string | undefined,
): OutbidToastPayload | null {
  if (frame.type !== 'bid.outbid') return null;
  const payload = frame.payload as
    | {
        itemId?: number | null;
        bundleId?: number | null;
        currentHighBidCents?: number;
        itemTitle?: string;
      }
    | undefined;
  const itemId = payload?.itemId ?? null;
  const bundleId = payload?.bundleId ?? null;
  if ((itemId == null && bundleId == null) || payload?.currentHighBidCents == null) return null;
  if (!eventSlug) return null;
  return {
    itemId,
    bundleId,
    // Title from the WS frame payload if available, else generic fallback
    // (the wire frame doesn't carry it today — GT1-360 follow-up).
    itemTitle: payload?.itemTitle ?? null,
    newHighBidCents: payload.currentHighBidCents,
    eventSlug,
    variant: 'outbid',
  };
}
